export default __webpack_public_path__ + "static/media/sponsor_4.305fad48.png";